import React, { Component } from 'react';

const SPEED = 26; // pixels per second

class Featured extends Component {
  constructor(props) {
    super(props);
    this.track = React.createRef();
    this.paused = false;
    this.resumeAt = 0;
    this.last = 0;
    this.pos = 0;
    this.step = this.step.bind(this);
    this.pause = this.pause.bind(this);
    this.resume = this.resume.bind(this);
    this.nudge = this.nudge.bind(this);
  }

  componentDidMount() {
    const reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) return;
    this.raf = window.requestAnimationFrame(this.step);
  }

  componentWillUnmount() {
    if (this.raf) window.cancelAnimationFrame(this.raf);
  }

  step(now) {
    const el = this.track.current;
    if (el) {
      const dt = this.last ? Math.min((now - this.last) / 1000, 0.1) : 0;
      const running =
        !this.paused && !document.hidden && now > this.resumeAt && dt > 0;
      // keep our own float position: assigning sub-pixel deltas straight to
      // scrollLeft gets rounded away and the track never moves
      if (Math.abs(el.scrollLeft - this.pos) > 2) this.pos = el.scrollLeft;
      if (running) {
        this.pos += SPEED * dt;
        const half = el.scrollWidth / 2;
        if (half > 0 && this.pos >= half) this.pos -= half;
        el.scrollLeft = this.pos;
      }
    }
    this.last = now;
    this.raf = window.requestAnimationFrame(this.step);
  }

  pause() {
    this.paused = true;
  }

  resume() {
    this.paused = false;
  }

  // hold the auto-scroll for a moment after any manual interaction
  nudge() {
    this.resumeAt = performance.now() + 2500;
  }

  scrollBy(direction) {
    const el = this.track.current;
    if (!el) return;
    const card = el.querySelector('.featured-card');
    const step = card ? card.getBoundingClientRect().width + 22 : 320;
    this.nudge();
    el.scrollBy({ left: direction * step, behavior: 'smooth' });
  }

  render() {
    const items = this.props.resumeFeatured || [];
    if (!items.length || !this.props.resumeBasicInfo) return null;
    const sectionName = this.props.resumeBasicInfo.section_name.featured;
    const loop = items.concat(items);

    return (
      <section id='featured'>
        <div className='col-md-12'>
          <h1>
            <span>{sectionName}</span>
          </h1>
          <div
            className='featured-wrap'
            onMouseEnter={this.pause}
            onMouseLeave={this.resume}
            onFocus={this.pause}
            onBlur={this.resume}
          >
            <button
              type='button'
              className='featured-arrow featured-arrow--prev'
              onClick={() => this.scrollBy(-1)}
              aria-label='Previous'
            >
              &#8249;
            </button>
            <div
              className='featured-track'
              ref={this.track}
              onTouchStart={this.nudge}
              onWheel={this.nudge}
            >
              {loop.map((item, i) => (
                <a
                  className='featured-card'
                  key={i}
                  href={item.url}
                  target='_blank'
                  rel='noopener noreferrer'
                  aria-hidden={i >= items.length ? 'true' : undefined}
                  tabIndex={i >= items.length ? -1 : undefined}
                >
                  <div className='featured-card__top'>
                    <span className='featured-card__kind'>{item.kind}</span>
                    {item.image ? (
                      <img src={item.image} alt='' className='featured-card__logo' />
                    ) : null}
                  </div>
                  <h4 className='featured-card__title'>{item.title}</h4>
                  <p className='featured-card__source'>{item.source}</p>
                  <p className='featured-card__desc font-trebuchet'>{item.description}</p>
                  <span className='featured-card__cta'>{item.cta || 'Open'} &rarr;</span>
                </a>
              ))}
            </div>
            <button
              type='button'
              className='featured-arrow featured-arrow--next'
              onClick={() => this.scrollBy(1)}
              aria-label='Next'
            >
              &#8250;
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export default Featured;
